import { invoke } from '@shared/easyfy.decorators';
import '@clientWebModules/socialmedia-share';

@invoke
export default class ArticleList {}
